import createSetItemField from 'owa-mail-store/lib/services/utils/createSetItemField';
/* tslint:disable:restrict-import-path */
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
/* tslint:enable:restrict-import-path */
import ItemChange from 'owa-service/lib/contract/ItemChange';
import itemChange from 'owa-service/lib/factory/itemChange';
import itemId from 'owa-service/lib/factory/itemId';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import UpdateItemResponseMessage from 'owa-service/lib/contract/UpdateItemResponseMessage';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import RequestOptions from 'owa-service/lib/RequestOptions';

function createRequestBody(itemIdsToUpdate: string[], isRead: boolean) {
    const userConfiguration = getUserConfiguration();
    const shouldSuppressReadReceipts = userConfiguration.UserOptions.ReadReceipt != 'AlwaysSend';
    const update = createSetItemField('IsRead', isRead);

    const itemChanges: ItemChange[] = [];
    itemIdsToUpdate.forEach(id =>
        itemChanges.push(
            itemChange({
                Updates: [update],
                ItemId: itemId({ Id: id }),
            })
        )
    );

    return updateItemRequest({
        ItemChanges: itemChanges,
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
        SuppressReadReceipts: shouldSuppressReadReceipts,
    });
}

/**
 * Marks an item as read/unread
 * @param itemIdsToUpdate Item ids to be updated
 * @param isRead read/unread boolean state
 * @param requestOptions request options to be passed in
 */
export default function markItemsAsReadService(
    itemIdsToUpdate: string[],
    isRead: boolean,
    requestOptions?: RequestOptions
): Promise<UpdateItemResponseMessage> {
    const requestBody = createRequestBody(itemIdsToUpdate, isRead);

    return updateItemOperation(
        {
            Header: getJsonRequestHeader(),
            Body: requestBody,
        },
        requestOptions
    ).then(response => {
        return response.Body.ResponseMessages.Items[0] as UpdateItemResponseMessage;
    });
}
